<template>
  <div>
  <div id="homePage-1" v-if=" this.$i18n.locale == 'zh'">
    <div class="page-left">
      <h1>
        <span>高品质 定制化</span>
        <span></span>
      </h1>
      <h3>企业全线数智应用服务</h3>
      <a href="#page3" class="view-detail">查看详情</a>
    </div>
    <div class="page-right">
      <img src="../../../assets/img/banner/banner_2.5D.jpg" alt="sanereman">
    </div>
  </div>

  <div id="homePage-1" v-if=" this.$i18n.locale == 'en'">
    <div class="page-left">
      <h1>
        <span>Digital Intelligence</span>
        <span></span>
      </h1>
      <h3>Full-time/Remote Service</h3>
      <a href="#page3" class="view-detail" > VIEW DETAIL</a>
    </div>
    <div class="page-right">
      <img src="../../../assets/img/banner/banner_2.5D.jpg" alt="sanereman">
    </div>
  </div>
</div>
</template>

<script>
export default {
  name: 'PageOne',
  data () {
    return {
    }
  },
}
</script>
<style lang="scss" scoped>
#homePage-1 {
  display: flex;
  flex-direction: row;
  justify-content: fixed;
  width: 100%;
  height: 100vh;
  background: url("~assets/img/banner/BGxian.png") center no-repeat,
              url('~assets/img/banner/page1_bgbg.jpg') center/200% no-repeat;
  color: #fff;
  >div {
    margin: auto;
  }
}

.page-right {
  img {
    justify-content: center;
    max-width: 100%;
    height: auto;
    display: block;
    animation: moveImage 5s infinite alternate;
  }

  @keyframes moveImage {
  0%{ -webkit-transform:translateX(80%); opacity:0;}
	70%{ -webkit-transform:translateX(-5%); opacity:1;}
	80%{ -webkit-transform:translateX(2%); opacity:1;}
	90%{ -webkit-transform:translateX(-2%); opacity:1;}
	100%{ -webkit-transform:translateX(0); opacity:1;} 
  }
}

.page-left {
  h1 {
    font-size: 58px;
    
  }
  h3 {
    font-size: 36px;
    
    margin-bottom: 44px;
    span {
   
      display: flex;
    }
  }
  .view-detail {
    margin:0 auto;
    font-size: 16px;
    line-height: 60px;
    display: block;
    width: 216px;
    height: 60px;
    transition: all .3s;
    text-align: center;
    border: 1px solid #fff;
    border-radius: 4px;
    color: #fff;
    &:hover {
      color: #072c69;
      background-color: #fff;
    }
  }
}
</style>
